module.exports = __webpack_public_path__ + "assets/webgl/Assets_3_base_color.jpg.569e1c3b.webp";